import { apiRequest } from '../../apiCall'


export const saveBusinessInfoRequest = (params) => apiRequest('company_info.save', params)

export const getBusinessInfoRequest = (params) => apiRequest('company_info.get', params)

